import React, { useEffect, useRef, useState } from 'react';
import { Button, Drawer, Space, Tooltip } from 'antd';
import Icon, { QuestionOutlined, DownloadOutlined, DatabaseOutlined } from '@ant-design/icons';

import Tool_2_PanelComponent from './widgets/Tool_2_PanelComponent';

import { ReactComponent as browserMap_icon } from '../../assets/images/esri/browser-map-32.svg'
import { ReactComponent as baseMap_icon } from '../../assets/images/esri/basemap-32.svg'
import { ReactComponent as measures_icon } from '../../assets/images/esri/measure-32.svg'
import { ReactComponent as layers_icon } from '../../assets/images/esri/layers-32.svg'
import { ReactComponent as legend_icon } from '../../assets/images/esri/legend-32.svg'
import { ReactComponent as user_icon } from '../../assets/images/esri/user-32.svg'
import { ReactComponent as information_icon } from '../../assets/images/esri/information-32.svg'
import { ReactComponent as filter_icon } from '../../assets/images/esri/filter-32.svg'
import { ReactComponent as table_icon } from '../../assets/images/esri/table-32.svg'
import { ReactComponent as trash_icon } from '../../assets/images/esri/trash-32.svg'
import { ReactComponent as bookmark_icon } from '../../assets/images/esri/bookmark-32.svg'
import { ReactComponent as search_coordenates_icon } from '../../assets/images/esri/search_coordinates-32.svg';
import { ReactComponent as location_map } from '../../assets/images/esri/location_map-32.svg';
import { ReactComponent as streetView } from '../../assets/images/esri/street-view-svgrepo-com.svg';
import { ReactComponent as export_icon } from '../../assets/images/esri/export-32.svg';
import { ReactComponent as edit_icon } from '../../assets/images/esri/layers-editable-32.svg';


import { default as info_cursor } from '../../assets/images/esri/cursors/info.cur'

import MapListComponent from './widgets/MapListComponent';
import BaseMapsComponent from './widgets/BaseMapsComponent';
import MeasuresComponent from './widgets/MeasuresComponent';
import LayersComponent from './widgets/LayersComponent';
import LegendComponent from './widgets/LegendComponent';
import LoginComponent from './widgets/LoginComponent';
import ExportComponent from './widgets/ExportComponent';
import EditorComponent from './widgets/EditorComponent';

import i18next from "i18next";
import { user_state } from '../../features/user/userSlice';
import { useSelector } from 'react-redux';
import MapToolComponent from './MapToolComponent';
import MapToolInfoFilterComponent from './widgets/filter/MapToolInfoFilterComponent';
import BookmarksComponent from "./widgets/BookmarksComponent";
import StreetViewComponent from "./widgets/StreetViewComponent";
import Modal from "antd/es/modal/Modal";
import Draggable from "react-draggable";
import { DraggableOnStart } from "./widgets/management/utils/DraggableOnStart";
import SearchCoordinatesComponent from './widgets/SearchCoordinatesComponent';
import VicaDownloads from '../vica/VicaDownloads';
import { Link } from 'react-router-dom';


import { queries_state } from '../../features/queries/queriesSlice';
import { isMobile } from 'react-device-detect';



const ToolBarComponent = ({ mapDiv, mapView, table,
    setMapConfig, mapConfig, mapCallBack, tableVisible, setTableVisible,
    setCoordenadas, setOverviewMapVisible, overviewMapVisible }) => {

    //console.log("ToolBarComponent mapConfig", mapConfig)

    const queriesstate = useSelector(queries_state)

    const userstate = useSelector(user_state);
    const mapToolComponent = useRef();

    const [componentInitialized, setComponentInitialized] = useState(false)
    const [tableHasResults, setTableHasResults] = useState()
    const [selectedToolName, setSeletedToolName] = useState(null)
    const [selectedToolId, setSeletedToolId] = useState(null)
    const [selectedTool, setSeletedTool] = useState(null)
    const [visiblePanels, setVisiblePanels] = useState([])
    const [viewHasGeometries, setViewHasGeometries] = useState(false)

    useEffect(() => {
        //console.log("tool", userstate)
        if (!componentInitialized) {
            mapView.graphics.on("after-changes", function (event) {
                setViewHasGeometries(mapView.graphics.length > 0);
            });
            setComponentInitialized(true)
        }
        setTableHasResults(table.hasResults());

    }, [table.hasResults()])



    const refPrintWidget = useRef();

    let selectableTools = ["info", "measures", "tool_0", "export", "streetview", "filter"];
    let panelTools = ["filter", "measures", "login", "layers", "legend", "mapList", "baseMap", "export", "tool_2", "bookmarks", "streetview", "search_coordinates", "location_map", "downloads", "editor"];
    let actionTools = ["table", "tool_3", "location_map", "help"];

    const setMapConfigCallBack = (mapConfig) => {
        setSeletedToolName(null);
        setSeletedToolId(null);
        setSeletedTool(null);
        setVisiblePanels([]);
        setMapConfig(mapConfig);
        mapCallBack(mapConfig)
    };

    const clearButton = useRef(null);//deletes measures
    const changeViewButton = useRef(null);//back to normal view

    const [streetViewKey, setStreetViewKey] = useState(0)

    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });

    const draggleRef = useRef(null);

    const toolClick = (toolName, toolId, tool) => {
        if (toolName == selectedToolName) {
            setSeletedToolName(null);
            setSeletedToolId(null);
            setSeletedTool(null);
            mapDiv.current.style.cursor = "auto";
        } else {
            if (selectableTools.includes(toolName)) {
                if (selectedToolName == "measures" && toolName != selectedToolName) {
                    clearButton.current.click()
                }
                if (selectedToolName == "streetview" && toolName != selectedToolName) {
                    changeViewButton.current.click()
                }
                mapDiv.current.style.cursor = renderCursor(toolName);
                //console.log(mapDiv.current);
                //console.log(renderCursor(tool));
                //url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'  width='128' height='80' viewport='0 0 100 100' style='fill:black;font-size:300px;'><text y='216%' x='-70%'>💩</text></svg>") 16 0,auto;
                setSeletedToolName(toolName);
                setSeletedToolId(toolId);
                setSeletedTool(tool);
                if (toolName == "streetview") {
                    //console.log("streetview is clicked")
                    setStreetViewKey(prevKey => prevKey + 1)
                }
            }
            if (visiblePanels.includes(selectedToolName)) {
                let visiblePanelsCopy = [...visiblePanels];
                var index = visiblePanelsCopy.indexOf(selectedToolName);
                if (index !== -1) {
                    visiblePanelsCopy.splice(index, 1);
                }
                setVisiblePanels(visiblePanelsCopy);

            }
        }

        if (panelTools.includes(toolName)) {
            if (toolName == selectedToolName) {
                closePanel(toolName);
            } else {
                let visiblePanelsCopy = [...visiblePanels];
                if (!visiblePanelsCopy.includes(toolName)) {
                    visiblePanelsCopy.push(toolName);
                    setVisiblePanels(visiblePanelsCopy);
                }
            }
        }

        if (actionTools.includes(toolName)) {
            if (toolName == "table") {
                setTableVisible(!tableVisible);
            }
            else if (toolName == "location_map") {
                setOverviewMapVisible(!overviewMapVisible)
            }
            else if (toolName == "help") {
                window.open("./Ayuda_VICA.pdf", "_blank", "noreferrer");
            }
            else {
                alert("TODO Action tool " + toolName);
            }
        }
    }

    const getToolStyle = (tool) => {
        if (tool == selectedToolName) return "primary";
        else return "default";
    }

    const closePanel = (tool) => {

        let visiblePanelsCopy = [...visiblePanels];
        var index = visiblePanelsCopy.indexOf(tool);
        if (index !== -1) {
            visiblePanelsCopy.splice(index, 1);
        }
        setVisiblePanels(visiblePanelsCopy);
        if (tool == selectedToolName) {
            if (tool == "measures") {
                clearButton.current.click()
            }
            if (tool == "streetview") {
                changeViewButton.current.click()
            }
            setSeletedToolName(null);
        }
    }

    const isPanelOpen = (tool) => {
        return visiblePanels.includes(tool);
    }

    function getToolbarStyle() {
        if (isMobile) {
            return {
                position: "absolute",
                top: "20px",
                right: "20px",
                left: "60px",
                zIndex: 1,
                textAlign: "center"
            }
        }
        else {
            return {
                position: "absolute",
                top: "20px",
                right: "20px",
                /*left: "60px",*/
                zIndex: 1,
                textAlign: "center",
                maxWidth: "55%"
            }
        }
    }


    const renderCursor = (tool) => {
        switch (tool) {
            case 'info':
                return "url('" + info_cursor + "') 0 0, pointer";
            default:
                return "auto";
        }
    }

    const renderIcon = (tool) => {
        switch (tool) {
            case 'filter':
                return <Icon component={filter_icon} />
            case 'table':
                return <Icon component={table_icon} />
            case 'info':
                return <Icon component={information_icon} />
            case 'measures':
                return <Icon component={measures_icon} />
            case 'layers':
                return <Icon component={layers_icon} />
            case 'legend':
                return <Icon component={legend_icon} />
            case 'mapList':
                return <Icon component={browserMap_icon} />
            case 'baseMap':
                return <Icon component={baseMap_icon} />
            case 'login':
                return <Icon component={user_icon} />
            case 'tool_0':
                return "T0"
            case 'export':
                return <Icon component={export_icon} />
            case 'tool_2':
                return "T2"
            case 'tool_3':
                return "T3"
            case 'bookmarks':
                return <Icon component={bookmark_icon} />
            case 'streetview':
                return <Icon component={streetView} />
            case 'search_coordinates':
                return <Icon component={search_coordenates_icon} />
            case 'location_map':
                return <Icon component={location_map} />
            case 'downloads':
                return <DownloadOutlined />
            case 'help':
                return <QuestionOutlined />
            case 'editor':
                return <Icon component={edit_icon} />
            default:
                return "?";
        }
    }

    function translateTools(name) {
        if (name == "measures") {
            return i18next.t('common.tools.measures.name')
        }
        else {
            return i18next.t('common.tools.' + name + '.name')
        }
    }

    const onStart = (_event, uiData) => {
        DraggableOnStart(_event, uiData, draggleRef, setBounds)
    };

    function getEditorDrawerPlacement() {
        if (isMobile) { return "bottom" }
        else { return "right" }
    }

    function  getEditorDrawerHeight(){
        if (isMobile) { return "45%" }
        else { return "100%" }
    }

    return (
        <>
            <MapToolComponent ref={mapToolComponent} mapDiv={mapDiv} mapView={mapView} table={table}
                mapConfig={mapConfig} selectedTool={selectedToolName} />

            <Space direction="vertical" style={getToolbarStyle()}>
                <Space wrap>
                    {mapConfig.sgvmapMapMaptoolList.map((mapTool, i) => {
                        let render = true;
                        //Si la herramienta es tabla, y no tenemos resultados que mostrar en la tabla, no mostramos el botón
                        if (mapTool.sgvmapMapTool.name == "table" && !tableHasResults) {
                            render = false;
                        }


                        if (render) {
                            return <Tooltip title={translateTools(mapTool.sgvmapMapTool.name)} key={mapTool.sgvmapMapTool.idMapTool}>
                                <Button size='large' onClick={() => toolClick(mapTool.sgvmapMapTool.name, mapTool.sgvmapMapTool.idMapTool, mapTool)}
                                    type={getToolStyle(mapTool.sgvmapMapTool.name)} shape="circle">
                                    {renderIcon(mapTool.sgvmapMapTool.name)}
                                </Button>
                            </Tooltip>
                        }

                    })}

                    {viewHasGeometries && <Tooltip title={i18next.t('common.tools.clear_graphics.name')} key='clear_graphics' placement="bottomRight">
                        <Button size='large' onClick={() => mapView.graphics.removeAll()}
                            type={"default"} shape="circle">
                            {<Icon component={trash_icon} />}
                        </Button>
                    </Tooltip>}

                    {
                        /*userstate.token && userstate.authorities.includes("iaa") &&*/
                        //HASTA QUE SE DEPURE, QUITAMOS EL ENLACE A ADMINISTRACIÓN
                        /*
                        <Tooltip title={i18next.t('common.tools.db_administration.name')} key='db_administration' placement="bottomRight">
                            <Link to='administration' target='_blank'>
                                <Button size='large' type={"default"} shape="circle">
                                    {<DatabaseOutlined />}
                                </Button>
                            </Link>
                        </Tooltip>
                        */
                    }
                </Space>
            </Space>

            <Drawer title={i18next.t('common.tools.export.name')} mask={false}
                afterOpenChange={(open) => {
                    if (open) {
                        refPrintWidget.current.parentOpened()
                    } else {
                        refPrintWidget.current.parentClosed()
                    }
                }}
                placement="right" onClose={() => closePanel("export")} open={isPanelOpen("export")}>
                <ExportComponent ref={refPrintWidget} mapView={mapView} />
            </Drawer>

            <Drawer title="Drawer tool 2"
                placement="right" onClose={() => closePanel("tool_2")} open={isPanelOpen("tool_2")}>
                <Tool_2_PanelComponent mapView={mapView} />
            </Drawer>

            <Modal title={i18next.t('common.tools.filter.name')} mask={false} style={{ float: "left", marginLeft: "4%", marginTop: "-2%" }}
                modalRender={(modal) => (
                    <Draggable
                        bounds={bounds}
                        onStart={(event, uiData) => onStart(event, uiData)}
                    >
                        <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                placement="right" onCancel={() => closePanel("filter")} onOk={() => closePanel("filter")} open={isPanelOpen("filter")} footer={null}>
                <MapToolInfoFilterComponent mapDiv={mapDiv} mapView={mapView} mapConfig={mapConfig} />
            </Modal>


            <Drawer title={i18next.t('common.tools.mapList.name')}
                placement="right" onClose={() => closePanel("mapList")} open={isPanelOpen("mapList")}>
                <>
                    <MapListComponent setMapConfig={setMapConfigCallBack} />
                </>
            </Drawer>

            <Drawer title={i18next.t('common.tools.baseMap.name')}
                placement="right" onClose={() => closePanel("baseMap")} open={isPanelOpen("baseMap")}>
                <>
                    <BaseMapsComponent mapView={mapView} />
                </>
            </Drawer>

            <Drawer title={i18next.t('common.tools.layers.name')}
                placement="right" onClose={() => closePanel("layers")} open={isPanelOpen("layers")}>
                <>
                    <LayersComponent mapView={mapView} table={table} mapConfig={mapConfig} />
                </>
            </Drawer>

            <Drawer title={i18next.t('common.tools.legend.name')}
                placement="right" onClose={() => closePanel("legend")} open={isPanelOpen("legend")}>
                <>
                    <LegendComponent mapView={mapView} />
                </>
            </Drawer>

            <Drawer title={userstate.logged ? i18next.t('common.tools.login.logged_as') : i18next.t('common.tools.login.login')}
                placement="right" onClose={() => closePanel("login")} open={isPanelOpen("login")}>
                <>
                    <LoginComponent mapView={mapView} />
                </>
            </Drawer>

            <Drawer title={i18next.t('common.tools.measures.name')} mask={false}
                placement="right" onClose={() => closePanel("measures")} open={isPanelOpen("measures")}>
                <MeasuresComponent mapView={mapView} mapDiv={mapDiv} clearButton={clearButton} />
            </Drawer>

            <Modal title={i18next.t('common.tools.bookmarks.name')}
                open={isPanelOpen("bookmarks")}
                onOk={() => closePanel("bookmarks")}
                onCancel={() => { closePanel("bookmarks"); }}>
                <BookmarksComponent mapView={mapView} />
            </Modal>

            {/*
            <Drawer title={i18next.t('common.tools.measures.bookmarks')} mask={false} width={'1200px'}
                placement="right" onClose={() => closePanel("bookmarks")} open={isPanelOpen("bookmarks")}>
                <>
                    <BookmarksComponent mapView={mapView} />
                </>
            </Drawer>
                */}

            <Drawer title={i18next.t('common.tools.search_coordinates.name')}
                placement="right" onClose={() => closePanel("search_coordinates")} open={isPanelOpen("search_coordinates")}>
                <>
                    <SearchCoordinatesComponent setCoordenadas={setCoordenadas} />
                </>
            </Drawer>

            <Drawer title={i18next.t('common.tools.downloads.name')}
                placement="right" onClose={() => closePanel("downloads")} open={isPanelOpen("downloads")}>
                <>
                    <VicaDownloads mapView={mapView} />
                </>
            </Drawer>

            <Drawer title={i18next.t('common.tools.editor.name')} mask={false}
                placement={getEditorDrawerPlacement()} height={getEditorDrawerHeight()} onClose={() => closePanel("editor")} open={isPanelOpen("editor")}>
                <>
                    <EditorComponent mapView={mapView} table={table} mapConfig={mapConfig} visiblePanels={visiblePanels}></EditorComponent>
                </>
            </Drawer>
        </>
    )
};
export default ToolBarComponent;